// src\themes\lino\elements\footer\FooterList.tsx
import Link from 'next/link';

import { MenuItem } from '@/core/types/menuApi';
import { Settings } from '@/core/types/landing';

type FooterListProps = {
  footerItems: MenuItem[];
  setting: Settings;
};

export default function FooterList({ footerItems }: FooterListProps) {
  return (
    <>
      {footerItems.map(item => (
        <div key={item.id}>
          <span className="block mb-5 text-[11px] uppercase tracking-[0.14em] text-primary-500">
            {item.title}
          </span>
          <ul className="space-y-3">
            {item.children?.map(child => (
              <li key={child.id}>
                <Link
                  href={child.link}
                  className="text-[13px] text-primary-700 hover:text-primary-900 transition-colors"
                >
                  {child.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}